import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import CustomField from './custom_field';
import LoadingSpinner from 'components/loading_spinner';
import Modal from './modal';
import withDragDropContext from 'helpers/react_dnd/with_drag_drop_context';
import { serialize, swapSortOrders } from './helpers';
import { get, put } from 'helpers/api';

export function CustomFields({ customFields: _customFields, features, options, paths }) {
  const [customFields, setCustomFields] = useState(_customFields);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    get(paths.customFields).then(setCustomFields);
  }, []);

  if (!customFields) {
    return <LoadingSpinner/>;
  }

  function setCustomField(customField) {
    const index = customFields.findIndex(existingField => existingField.name === customField.name);
    const newCustomFields = [...customFields];
    newCustomFields[index] = customField;
    setCustomFields(newCustomFields);
  }

  function removeCustomField(removedField) {
    setCustomFields(customFields.filter(customField => customField.name !== removedField.name));
  }

  function saveOrder() {
    put(paths.customFields, {
      customFields: customFields.map(customField => serialize(customField, customFields, options)),
    });
  }

  return (
    <div>
      <AddControl id="add-custom-field" onClick={() => setShowModal(true)}>
        Add custom field
      </AddControl>

      <table className="ds-table mt-2">
        <thead>
          <tr>
            <th/>
            <th>Label</th>
            {features.edge && <th>Record types</th>}
            <th>Type</th>
            <th>Category</th>
            <th>Section</th>
            {features.marketingIntegration && <th>Marketing field</th>}
            <th width="0"></th>
          </tr>
        </thead>
        <tbody>
          {customFields.map(customField => (
            <CustomField
              customField={customField}
              customFields={customFields}
              features={features}
              key={customField.name}
              options={options}
              paths={paths}
              onChange={setCustomField}
              onDelete={removeCustomField}
              onDragHover={(name1, name2) => setCustomFields(swapSortOrders(customFields, name1, name2))}
              onDrop={saveOrder}
            />
          ))}
        </tbody>
      </table>

      <Modal
        customFields={customFields}
        features={features}
        options={options}
        paths={paths}
        show={showModal}
        onHide={() => setShowModal(false)}
        onSave={customField => setCustomFields([...customFields, customField])}
      />
    </div>
  );
}

CustomFields.propTypes = {
  customFields: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })).isRequired,
  features: PropTypes.shape({
    edge: PropTypes.bool,
    marketingIntegration: PropTypes.bool,
  }).isRequired,
  options: PropTypes.object.isRequired,
  paths: PropTypes.object.isRequired,
};

export default withDragDropContext(CustomFields);
